import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3q81j74wux: FaireBrandEntity = {
  token: "b_3q81j74wux",
  type: "brand",
  name: "KIMBERLY C",
  avatarUrl:
    "https://cdn.faire.com/fastly/d12f0f70987057942b8831fbb49e7da10eaf94c7fadfefb1043e658400ae9d0c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b423e3784dbcf5af20014b4f36403a8d067aaedebeeaca68065484facd9cd288.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d12f0f70987057942b8831fbb49e7da10eaf94c7fadfefb1043e658400ae9d0c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b423e3784dbcf5af20014b4f36403a8d067aaedebeeaca68065484facd9cd288.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 189,
  isTopShop: true,
  isInsider: true,
  description:
    "KIMBERLY C is a leading athleisure brand that provides trendy contemporary styles for the modern woman. We are dedicated to taking you from life to leisure confidently. Whether that be at work, moving your body at the gym, or lounging at home, we want to make sure you're covered for all that life throws at you. Everyone deserves to feel strong and beautiful anywhere they go.\n\nKIMBERLY C believes that customer satisfaction is our top priority which is why we spend countless hours in design and production to bring you the latest styles and the highest quality, at the market's most competitive prices.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.539Z",
    importedBy: "entity-db-cli",
  },
};
